"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPersonLD = exports.buildVideoObjectListLD = exports.buildVideoObjectLD = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const duration_1 = __importDefault(require("dayjs/plugin/duration"));
dayjs_1.default.extend(duration_1.default);
const interactionStatistic = (videoMetadata) => {
    const interactionStatistic = [];
    if (videoMetadata.viewCount) {
        interactionStatistic.push({
            "@type": "InteractionCounter",
            interactionType: {
                "@type": "WatchAction",
            },
            userInteractionCount: parseInt(videoMetadata.viewCount, 10),
        });
    }
    if (videoMetadata.shareCount) {
        interactionStatistic.push({
            "@type": "InteractionCounter",
            interactionType: {
                "@type": "ShareAction",
            },
            userInteractionCount: parseInt(videoMetadata.shareCount, 10),
        });
    }
    return { interactionStatistic };
};
const creator = (videoMetadata) => {
    if (videoMetadata.creator?.$case === "personCreator") {
        const personCreator = videoMetadata.creator.personCreator;
        return {
            creator: {
                "@context": "https://schema.org",
                "@type": "Person",
                alternateName: personCreator.username,
                url: personCreator.url,
                name: personCreator.name,
            },
        };
    }
    else {
        return {};
    }
};
const uploadDateMs = (videoMetadata) => {
    if (videoMetadata.uploadDateMs === "0") {
        return;
    }
    return new Date(parseInt(videoMetadata.uploadDateMs, 10)).toISOString();
};
const duration = (videoMetadata) => {
    if (videoMetadata.durationMs === "0") {
        return {};
    }
    return {
        duration: dayjs_1.default.duration(parseInt(videoMetadata.durationMs, 10), "ms").toISOString(),
    };
};
const dimensions = (videoMetadata) => {
    if (videoMetadata.width && videoMetadata.height) {
        return {
            width: `${videoMetadata.width} px`,
            height: `${videoMetadata.height} px`,
        };
    }
    else {
        return {};
    }
};
const buildVideoObject = (videoMetadata, index) => {
    const { name, description, thumbnailUrl, contentUrl } = videoMetadata;
    const uploadDate = uploadDateMs(videoMetadata);
    const videoObject = {
        "@type": "VideoObject",
        name,
        description,
        thumbnailUrl,
        uploadDate,
        ...interactionStatistic(videoMetadata),
        contentUrl,
        ...creator(videoMetadata),
        ...duration(videoMetadata),
        ...dimensions(videoMetadata),
        encodingFormat: "video/mp4",
        isFamilyFriendly: true,
    };
    if (typeof index === "number") {
        return {
            ...videoObject,
            position: index + 1,
        };
    }
    return videoObject;
};
function buildVideoObjectLD(videoMetadata) {
    const videoObject = buildVideoObject(videoMetadata);
    return {
        "@context": "https://schema.org",
        ...videoObject,
    };
}
exports.buildVideoObjectLD = buildVideoObjectLD;
/**
 * Generates a list of video objects, needed for video carousels
 * @see https://developers.google.com/search/docs/appearance/structured-data/carousel
 * @param videoMetadata The data for each VideoObject item
 */
function buildVideoObjectListLD(videoMetadata) {
    const videoObjects = videoMetadata
        .map(buildVideoObject)
        // Certain empty properties are seen as invalid by Google, drop the entries here if necessary:
        .filter(({ name, thumbnailUrl, uploadDate }) => !(!name || !thumbnailUrl || !uploadDate));
    return {
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement: videoObjects,
    };
}
exports.buildVideoObjectListLD = buildVideoObjectListLD;
function buildPersonLD(userProfile) {
    const person = {
        "@context": "https://schema.org",
        "@type": "Person",
    };
    if (userProfile?.$case === "userInfo") {
        // Private profile
        if (userProfile.userInfo.bitmoji3d?.avatarImage) {
            person.image = userProfile.userInfo.bitmoji3d.avatarImage.url;
        }
        else {
            person.image = userProfile.userInfo.snapcodeImageUrl;
        }
        person.name = userProfile.userInfo.displayName;
        // Making sure to use every bit of info we have here
        person.alternateName = userProfile.userInfo.username;
        person.url = `https://www.snapchat.com/add/${userProfile.userInfo.username}`;
    }
    else if (userProfile?.$case === "publicProfileInfo") {
        // Public profile
        person.address = userProfile.publicProfileInfo.address;
        person.alternateName = userProfile.publicProfileInfo.username;
        person.description = userProfile.publicProfileInfo.bio;
        person.image = userProfile.publicProfileInfo.profilePictureUrl;
        person.name = userProfile.publicProfileInfo.title;
        person.url = `https://www.snapchat.com/add/${userProfile.publicProfileInfo.username}`;
    }
    return person;
}
exports.buildPersonLD = buildPersonLD;
//# sourceMappingURL=index.js.map